import { UploadImage } from "../components/molecules";
import { API_ENDPOINTS } from "../constants/api";
import { CreateEquipmentData, Equipment, EquipmentDTO, EquipmentUploadImagesResponse } from "../types/equipment";
import { apiService } from "./api/api";



export class EquipmentService {
  async getEquipmentById(id: string): Promise<Equipment | null> {
    try {
      const response = await apiService.get<Equipment>(`${API_ENDPOINTS.EQUIPMENT.GET}/${id}`);
      return response;
    } catch (error) {
      console.error(`Error fetching equipment with ID ${id}:`, error);
      return null;
    }
  }

  async updateEquipment(id: string, data: EquipmentDTO): Promise<Equipment> {
    return await apiService.put<Equipment>(`${API_ENDPOINTS.EQUIPMENT.UPDATE}/${id}`, data);
  }

  async deleteEquipment(id: string): Promise<void> {
    await apiService.delete(`${API_ENDPOINTS.EQUIPMENT.DELETE}/${id}`);
  }

  async createEquipment(data: CreateEquipmentData): Promise<Equipment> {
    return await apiService.post<Equipment>(API_ENDPOINTS.EQUIPMENT.CREATE, data);
  }

  async getAllEquipments(): Promise<Equipment[]> {
    return await apiService.get<Equipment[]>(API_ENDPOINTS.EQUIPMENT.ALL);
  }

  async uploadImages(id: string, images: UploadImage[]): Promise<EquipmentUploadImagesResponse> {
    const form = new FormData();

    for (const image of images) {
      if (image.file && image.file instanceof File) {
        form.append("files", image.file, image.file.name);
      }
    }
    return await apiService.post(
      `${API_ENDPOINTS.EQUIPMENT.UPLOAD_IMAGES.replace(":id", id)}`,
      form,
      {
        transformRequest: (data) => data
      }
    );
  }

  async deleteImage(id: string, imageId: string): Promise<void> {
    await apiService.delete(
      `${API_ENDPOINTS.EQUIPMENT.DELETE_IMAGE.replace(":id", id).replace(":imageId", imageId)}`
    );
  }

  async reorderImages(id: string, imageIds: string[]): Promise<void> {
    console.log(`Reordering images for equipment ID ${id}:`, imageIds);
    await apiService.patch(`${API_ENDPOINTS.EQUIPMENT.REORDER_IMAGES.replace(":id", id)}`, { imageIds });
  }

  async manageImages(editingEquipment: Equipment, images: UploadImage[]): Promise<void> {
    const equipmentId = editingEquipment.id;

    images = images.map((img, index) => {
      return {
        ...img,
        index
      }
    });
    const newImages = images.filter((img) => !img.id && (img.file && img.file instanceof File))

    if (newImages.length > 0) {
      const responseImages = await this.uploadImages(equipmentId, newImages);
      responseImages.urls.forEach((url, index) => {
        newImages[index].url = url.url;
        newImages[index].id = url.id;
      });
      images = images.map((img) => {
        const newImage = newImages.find((i) => i.index === img.index);
        return newImage ? { ...img, ...newImage } : img;
      });
    }

    const removedImages = editingEquipment.images.filter(img => !images.find(i => i.id === img.id));
    for (const img of removedImages) {
      await this.deleteImage(equipmentId, img.id);
    }

    const reorderImagesIds = images.map(img => img.id).filter(Boolean) as string[];
    if (reorderImagesIds.length > 0) {
      await this.reorderImages(equipmentId, reorderImagesIds);
    }
  }
}

export const equipmentService = new EquipmentService();